import { CameraOutlined } from "@ant-design/icons";
import { App as AntApp, Alert, Button } from "antd";
import { useSnapshot, useStatus } from "../api/queries.js";
import { useAuth } from "../auth/AuthContext.js";
import { timeAgo } from "../format.js";

function Instrument({
  label,
  value,
  sub,
  accent,
}: {
  label: string;
  value: string;
  sub?: string;
  accent?: boolean;
}) {
  return (
    <div className={`instrument ${accent ? "accent" : ""}`}>
      <span className="microlabel">{label}</span>
      <div className="value">
        {value}
        {sub && <small> {sub}</small>}
      </div>
    </div>
  );
}

export function StatusPage() {
  const { message } = AntApp.useApp();
  const { user } = useAuth();
  const status = useStatus();
  const snapshot = useSnapshot();
  const isAdmin = user?.roles.includes("rw:*") ?? false;

  if (status.isError) {
    return (
      <Alert
        type="error"
        showIcon
        message="config server unreachable"
        description="The dashboard could not reach the configuration server's manage API. Check that it is running and CONF_MANAGE_URL / CONF_AUTH_TOKEN are correct."
      />
    );
  }

  const data = status.data;

  return (
    <div>
      <div className="instrument-grid">
        <Instrument label="update id" value={data ? `#${data.updateId}` : "—"} accent />
        <Instrument label="applications" value={data ? String(data.applications) : "—"} />
        <Instrument label="live properties" value={data ? String(data.properties) : "—"} />
        <Instrument label="active subscriptions" value={data ? String(data.activeSubscriptions) : "—"} />
        <Instrument
          label="last snapshot"
          value={data ? (data.lastSnapshotAt ? timeAgo(data.lastSnapshotAt) : "never") : "—"}
          sub={data && data.lastSnapshotUpdateId ? `#${data.lastSnapshotUpdateId}` : undefined}
        />
        <Instrument label="server uptime" value={data ? timeAgo(data.startedAt).replace(" ago", "") : "—"} />
      </div>
      <div style={{ marginTop: 18 }}>
        <Button
          icon={<CameraOutlined />}
          disabled={!isAdmin}
          loading={snapshot.isPending}
          onClick={() =>
            snapshot.mutate(undefined, {
              onSuccess: (result) => void message.success(`snapshot: ${result.file}`),
              onError: (error) => void message.error(error.message),
            })
          }
        >
          Snapshot now
        </Button>
        {!isAdmin && (
          <span className="dim" style={{ marginLeft: 10, fontSize: 11 }}>
            requires the rw:* role
          </span>
        )}
      </div>
    </div>
  );
}
